import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.widget.research.graph');
import { OnInit, OnDestroy, Input, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import ApexCharts from 'apexcharts';

@Component({
    selector: 'wiz-portal-gsdcuser-widget-research-graph',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.widget.research.graph/view.scss */
/* src/app/portal.gsdcuser.widget.research.graph/view.scss: no such file or directory */`],
})
export class PortalGsdcuserWidgetResearchGraphComponent implements OnInit, OnDestroy {
    @Input() dashboard: boolean = false;
    @Input() compact: boolean = false;
    public community: string[] = [];
    public years: string[] = [];
    public count: number[] = [];
    public series: any;
    public unknownCount = 0;
    public outsidePeriodCount = 0;
    public loadError = false;
    private chart: any;

    @ViewChild('chart')
    public element: ElementRef;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
        await this.buildChart();
    }

    public async load() {
        try {
            const response: any = await wiz.call("load");
            if (response?.code !== 200 || !Array.isArray(response.data?.years)
                || !Array.isArray(response.data?.count) || !Array.isArray(response.data?.community)
                || response.data.years.length !== response.data.count.length) {
                throw new Error('RESEARCH_SUMMARY_UNAVAILABLE');
            }
            const data = response.data;
            this.community = data.community;
            this.years = data.years.map(String);
            this.count = data.count;
            this.unknownCount = data.unknown_count || 0;
            this.outsidePeriodCount = data.outside_period_count || 0;
            this.series = [{ name: '건수', data: this.count }];
            this.loadError = false;
        } catch (_) {
            this.series = undefined;
            this.loadError = true;
        }
        await this.service.render();
    }

    public async buildChart() {
        if (!this.series || !this.element) return;
        const dashboard = !!this.element.nativeElement.closest('.gsdc-dashboard');
        const maxCount = Math.max(0, ...this.count);
        const axisMax = maxCount <= 5 ? Math.max(1, maxCount) : Math.ceil(maxCount / 5) * 5;
        const options = {
            series: this.series,
            chart: {
                type: 'bar', height: dashboard ? 220 : (this.compact ? 220 : 300), parentHeightOffset: dashboard || this.compact ? 0 : 15, fontFamily: 'SUIT, sans-serif',
                toolbar: {show: false},
                animations: {enabled: !window.matchMedia('(prefers-reduced-motion: reduce)').matches}
            },
            colors: [dashboard ? '#62b8ef' : '#2376b7'],
            plotOptions: {bar: {distributed: false, borderRadius: 4, columnWidth: '38%', dataLabels: {position: 'top'}}},
            legend: {show: false},
            dataLabels: {
                enabled: true, offsetY: -20,
                style: {fontSize: '12px', fontWeight: 600, colors: [dashboard ? '#e8f4ff' : '#415a73']},
                background: {enabled: false}, formatter: (value: number) => String(value)
            },
            grid: {borderColor: '#e5ebf2', strokeDashArray: 4, padding: {top: 30}},
            xaxis: {
                categories: this.years,
                labels: {show: true, rotate: 0, rotateAlways: false, trim: false},
                title: {text: '출판 연도'}, tooltip: {enabled: false}
            },
            yaxis: {
                min: 0, max: axisMax, tickAmount: Math.min(5, axisMax), decimalsInFloat: 0,
                title: {text: '건수'}
            },
            responsive: [{breakpoint: 768, options: {chart: {height: dashboard ? 240 : (this.compact ? 220 : 280)},
                xaxis: {labels: {style: {fontSize: '11px'}}}}}]
        };
        this.chart = new ApexCharts(this.element.nativeElement, options);
        await this.chart.render();
    }

    public ngOnDestroy() {
        this.chart?.destroy();
    }
}

export default PortalGsdcuserWidgetResearchGraphComponent;